import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useDeleteRegistrations = () => {
  const [error, setError] = useState(null)
  const i18n = useTranslation()
  const queryClient = useQueryClient()

  const mutation = useApiMutation(
    'schools',
    ({ registrationId }) => `/registrations/${registrationId}`,
    'delete',
    {
      onSuccess: () => {
        notification.info({
          style: { fontWeight: 500, fontSize: 17 },
          message: i18n.t('common.resources.registration.actions.destroy.success'),
          duration: 5
        })
        queryClient.removeQueries({ queryKey: ['registrations'], type: 'inactive' })
        queryClient.invalidateQueries({ queryKey: ['registrations'] })
      },
      onError: error => {
        setError(error)
      }
    },
    { authenticated: true, version: 4 }
  )

  const deleteRegistrations = async registrationId => {
    return mutation.mutateAsync({ registrationId })
  }

  return {
    loading: mutation.isPending,
    error,
    deleteRegistrations
  }
}
